import { render, staticRenderFns } from "./BuildingSubdivisionAction.global.vue?vue&type=template&id=728ef244&lang=pug&"
import script from "./BuildingSubdivisionAction.global.vue?vue&type=script&lang=js&"
export * from "./BuildingSubdivisionAction.global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports